import React, { Component } from 'react';
import { Button, message, DatePicker, Tabs, Modal, Radio } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const yearFormat = 'YYYY';
const { TabPane } = Tabs;
const RadioGroup = Radio.Group;
const monthFormat = 'YYYY-MM';
let yearMonth = moment().format(monthFormat)

class Filter extends Component {
    handleChange = (params, key) => {
        params.begin = moment(params.begin).format(monthFormat);
        params.end = moment(params.end).format(monthFormat);
        if(Math.abs(moment(params.begin).diff(params.end,'M')) > 11 || moment(params.begin).diff(params.end,'M') > 0){
            params.end = moment(params.begin).format(monthFormat);
        }
        this.props.onChange(params, key);
    }

    disabledDate = (current, key) => {
        const { params } = this.props;
        const currentValue = current.valueOf();
        if ( key == 'begin'){
            return current && (currentValue < moment(params.end).add(-11, 'M') || currentValue > moment(params.end));
        }else {
            return current && ( currentValue < moment(params.begin) || currentValue > moment(params.begin).add(11, 'M') );
        }
    };

    render() {
        const { businessList, searchTime = true, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = []
        searchTime && filters.push({
            name: '统计时间',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '~',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate:current => this.disabledDate(current, 'end'),
            }
        })
        filters.push({
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
                defaultValue:'-1'
            }
        },{
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: { limit: 20, status: 'ALL' },
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        });
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class ProjectMonSta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            visible: false,
            sortParams: {},
            businessList:[],
            dateList:[],
            searchParams: {
                begin: `${yearMonth}`,
                end: `${yearMonth}`,
                lineOfBusiness: '-1',
            },
            curParams: {
                begin: `${yearMonth}`,
                end: `${yearMonth}`,
                lineOfBusiness: '-1',
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            exportType: null,
            activeKey: this.props.activeKey,
        }
    }


    componentDidMount() {
        this.loadData();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const businessList = res.typeConfigureList.slice();
            businessList.unshift({ typeValue: '所有项目', typeConfigureId: -1 });
            this.setState({ businessList });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination, activeKey } = this.state;
        const { loadDataUrl, statisticalType } = this.props.config;
        const { current, pageSize } = pagination;
        const params = this.splitParams(curParams);
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: loadDataUrl,
            data: {
                offset: current,
                limit: pageSize,
                statisticalType,
                ...sortParams,
                ...params,
                exportType:activeKey,
                lineOfBusiness:params.lineOfBusiness === '-1' ? null : params.lineOfBusiness,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount, data } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    dateList:data,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }
    
    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams, exportType } = this.state;
        const params = this.splitParams(curParams);
        const {exportModal = false, config:{ exportUrl, statisticalType } } = this.props;
        if(exportModal && !exportType) {
            message.error('请选择导出内容！')
            return
        }
        const options = {
            method: 'POST',
            url: exportUrl,
            data: {
                ...sortParams,
                ...params,
                statisticalType,
                offset: 1,
                exportType,
                lineOfBusiness:params.lineOfBusiness === '-1' ? null : params.lineOfBusiness,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.onCancel()
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getDateColimns = () => {
        const { dateList } = this.state;
        const dateCol = [];
        (dateList || []).map((el, index) => {
            dateCol.push({
                title: el,
                dataIndex: el,
                key: el,
                width: 80,
                render: (text, record) => {
                    const { planAmounts, actualAmounts } = record;
                    return planAmounts[index] + '/' + actualAmounts[index]
                }
            })
        })
        return dateCol
    }

    getColumns = () => {
        const columns = [{
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 130,
        }, {
            title: '项目分类',
            dataIndex: 'typeName',
            key: 'typeName',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 100,
        }, {
            title: '项目PM工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 100,
        }, {
            title: '项目PM姓名',
            dataIndex: 'pmUser',
            key: 'pmUser',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 120,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '中心科室名称',
            dataIndex: 'siteDepartmentName',
            key: 'siteDepartmentName',
            width: 160,
        }, {
            title: '医院主管姓名',
            dataIndex: 'hospitalLeaderName',
            key: 'hospitalLeaderName',
            width: 100,
        }, {
            title: '医院主管工号',
            dataIndex: 'hospitalLeaderCode',
            key: 'hospitalLeaderCode',
            width: 100,
        }];
        if( this.props.config.statisticalType == 'Type_VisitType') {
            columns.push({
                title: '访视类型',
                dataIndex: 'visitTypeName',
                key: 'visitTypeName',
                width: 140,
            })
        }
        columns.push({
            title: '类型',
            dataIndex: 'statisticsTpeName',
            key: 'statisticsTpeName',
            width: 80,
        })
        columns.push(...this.getDateColimns())
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
            exportType:activeKey,
        }, () => {
            this.loadData();
        });
    }

    handelsRadioChange = e => {
        this.setState({ exportType: e.target.value })
    }

    exportModalShow = () => {
        this.setState({ visible:true })
    }

    onCancel = () => {
        this.setState({ visible:false, exportType:null })
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams, businessList, activeKey, visible, exportType } = this.state;
        const { panes, exportModal = false, searchTime = true, specialTip = false } = this.props;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            paddingLeft: '30px',
        };
        const columns = panes ? panes.find(el => { return el.key == activeKey}).columns : this.getColumns();
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    businessList={businessList}
                    searchTime={searchTime}
                    buttons={[
                        <Button key="export" type="primary" onClick={exportModal ? this.exportModalShow : this.export} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>{`注：由于数据量过大，页面仅展示其中一个项目${specialTip ? '' :'一个中心'}的数据，请导出后查看完整数据`}</div>
                {
                    panes &&
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                        {panes.map(pane => <TabPane tab={pane.title} key={pane.key} >{pane.content}</TabPane>)}
                    </Tabs>
                }
                
                <TableC
                    data={data}
                    loading={loading}
                    className="crcMonthInGroup"
                    sortParams={sortParams}
                    columns={columns}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                {
                    panes &&
                    <Modal
                        title='导出'
                        visible={visible}
                        maskClosable={false}
                        width={350}
                        onOk={this.export}
                        onCancel={this.onCancel}
                    >
                        <div>
                            <div>请选择导出内容：</div>
                            <RadioGroup onChange={e => this.handelsRadioChange(e)} value={exportType}>
                                {panes.map(pane => <Radio style={radioStyle} value={pane.key}>{pane.title}</Radio>)}
                            </RadioGroup>
                        </div>
                    </Modal>
                }
                
            </div>
        );
    }
}

export default ProjectMonSta;


// WEBPACK FOOTER //
// ./src/components/homePage/components/ProjectMonSta.js